(() => {
  const buttonSelector = '.m-wishlist-button';
  const addedClass = 'added-to-wishlist';
  const feedbackClass = 'pq-wishlist-just-added';
  const feedbackDuration = 650;
  const activeIconMarkup = `
    <span class="m-tooltip-icon--active" aria-hidden="true">
      <svg class="m-svg-icon--medium" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"/>
      </svg>
    </span>
  `;

  const wishlistButtons = () => Array.from(document.querySelectorAll(buttonSelector));

  const prepareButton = (button) => {
    if (!button.querySelector('.m-tooltip-icon--active')) {
      button.insertAdjacentHTML('beforeend', activeIconMarkup);
    }
  };

  const prepareButtons = (root = document) => {
    if (root instanceof Element && root.matches(buttonSelector)) {
      prepareButton(root);
    }

    if (typeof root.querySelectorAll === 'function') {
      root.querySelectorAll(buttonSelector).forEach(prepareButton);
    }
  };

  const syncPressedState = () => {
    wishlistButtons().forEach((button) => {
      prepareButton(button);
      button.setAttribute('aria-pressed', String(button.classList.contains(addedClass)));
    });
  };

  const playAddedFeedback = (productHandle, sourceButton) => {
    wishlistButtons()
      .filter((button) => {
        if (!button.classList.contains(addedClass)) return false;
        if (!productHandle) return button === sourceButton;
        return button.dataset.productHandle === productHandle;
      })
      .forEach((button) => {
        button.classList.remove(feedbackClass);
        void button.offsetWidth;
        button.classList.add(feedbackClass);
        window.setTimeout(() => button.classList.remove(feedbackClass), feedbackDuration);
      });
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target instanceof Element ? event.target.closest(buttonSelector) : null;
      if (!button) return;

      prepareButton(button);
      const wasAdded = button.classList.contains(addedClass);
      const productHandle = button.dataset.productHandle;

      window.setTimeout(() => {
        syncPressedState();
        if (!wasAdded && button.classList.contains(addedClass)) {
          playAddedFeedback(productHandle, button);
        }
      }, 0);
    },
    true
  );

  const initialize = (root = document) => {
    prepareButtons(root);
    syncPressedState();
    window.setTimeout(syncPressedState, 0);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  if ('MutationObserver' in window) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) prepareButtons(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
